import script from "./AdminTumorBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTumorBoard.vue?vue&type=script&setup=true&lang=js"

import "./AdminTumorBoard.vue?vue&type=style&index=0&id=18ebfd40&lang=css"

const __exports__ = script;

export default __exports__